import type { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { addEditedField } from '../../../../../app/sliceUtils';
import type { VerificationDetail } from '../../index';
import type { VerificationSliceState } from '../state';

/**
 * Core verification reducers (set / clear / edit). Edit tracking + validation reducers come from
 * `createEditTrackingReducers` / `createValidationReducers` in `app/sliceUtils` (spread in `index.ts`).
 *
 * NOTE: `VerificationDetail` is intentionally minimal in this slice (spec 004 has no editable
 * verification fields yet). `editVerification` is scaffolding: it shallow-merges a partial and marks
 * the touched fields, ready for the first editable section (005 Coverage onward).
 */
export const setVerification: CaseReducer<VerificationSliceState, PayloadAction<VerificationDetail>> = (
  state,
  action,
) => {
  state.current = action.payload;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

export const clearVerification: CaseReducer<VerificationSliceState> = (state) => {
  state.current = null;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

export const editVerification: CaseReducer<VerificationSliceState, PayloadAction<Partial<VerificationDetail>>> = (
  state,
  action,
) => {
  if (!state.current)
    return;

  Object.assign(state.current, action.payload);
  for (const field of Object.keys(action.payload))
    addEditedField(state, field);
};
